import React from 'react'
import { useQuery } from '@tanstack/react-query'
import PageIntro from './desktop_components/intro_section/IntroSection'
import MobilePageIntro from './mobile_components/intro_section/MobileIntroSection'
import EventsSection from './desktop_components/events_section/EventsSection'
import Header from '../menu/Header'
import ReviewsSection from './desktop_components/reviews_section/ReviewsSection'
import { GeneralTexts, HistorySectionTexts, HomeIntroTexts } from "../../enums/page_texts/homepage_texts";
import { TopSectionsPictures, HomeHistorySectionPictures } from '../../enums/images'
import DescriptiveSection from '../general/DescriptiveSection'
import HistorySection from './desktop_components/history_section/HistorySection'
import GallerySection from './desktop_components/gallery_section/GallerySection'
import { fetchGalleryCards, fetchPhotosAndReviews, loadHomePageData,  } from '../../services/api'
import LoadingSpinner from '../general/LoadingSpinner'
import StaticFooter from '../footer/StaticFooter'
import Footer from '../footer/Footer'
import MobileFooter from '../footer/MobileFooter'
import { GalleryCard, PhotoOrReview } from '../../interfaces/types'
import useWindowSize from '../../services/useWindowSize'
import SeoHelmet from '../general/SeoHelmet'
import ApiErrorScreen from '../general/ApiErrorScreen'

import { isMobile } from 'react-device-detect'
import MobileEventsSection from './mobile_components/events_section/MobileEventSection'
import MobileGallerySection from './mobile_components/gallery_section/MobileGallerySection'

const galleryTitle = "Quelques souvenirs"


const HomePage: React.FC = () => {
  useWindowSize();

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['home-page'],
    queryFn: async () => {
      const [photosAndReviews, galleryCards] = await Promise.all([
        fetchPhotosAndReviews() as Promise<PhotoOrReview[]>,
        fetchGalleryCards() as Promise<GalleryCard[]>,
        loadHomePageData(),
      ])
      return { photosAndReviews, galleryCards }
    },
  })

  if (isLoading) {
    return <LoadingSpinner />
  }

  if (isError || !data) {
    return <ApiErrorScreen onRetry={() => refetch()} />
  }

  const { photosAndReviews, galleryCards } = data
  const historyMainImage = HomeHistorySectionPictures.MainPicture
  const historySmallImages = [
    HomeHistorySectionPictures.TopLeftPicture,
    HomeHistorySectionPictures.TopRightPicture,
    HomeHistorySectionPictures.BottomLeftPicture,
    HomeHistorySectionPictures.BottomRightPicture,
  ]

  return (
    <div>
      <SeoHelmet
        title="DJ Mayday | DJ Liège & Wallonie — Mariages, Soirées, Événements"
        description="DJ Mayday, DJ professionnel basé à Ouffet, anime vos événements privés et publics à Liège et dans toute la Wallonie. Mariages, anniversaires, soirées d'entreprise, festivals."
        url="https://www.djmayday.com"
      />
      <h1 style={{ position: 'absolute', width: '1px', height: '1px', padding: 0, margin: '-1px', overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0 }}>
        DJ Mayday — DJ Liège & Wallonie | Mariages, Soirées, Événements privés et publics
      </h1>
      <Header />
      {/* INTRO BANNER */}
      {!isMobile && (
        <div id="desktop_content">
          <PageIntro title={GeneralTexts.Name}
            description={HomeIntroTexts.DescriptiveText}
            backgroundImage={TopSectionsPictures.HomePage}
            modalText={HomeIntroTexts.ModalText}
            buttonText={HomeIntroTexts.ButtonText}
            aboutModal={HomeIntroTexts.AboutModal}
            closeModal={HomeIntroTexts.CloseModal}
            isModalList={true} />
          <EventsSection />
          {/* HISTORY */}
          <HistorySection title={HistorySectionTexts.Title} subtitle={HistorySectionTexts.Subtitle} description={HistorySectionTexts.Description} mainImage={historyMainImage} smallImages={historySmallImages} />
          {/* REVIEWS */}
          <DescriptiveSection title="Ce qu'ils en ont pensé">
            <ReviewsSection items={photosAndReviews} />
          </DescriptiveSection>
          {/* GALLERY */}
          <GallerySection title={galleryTitle} cards={galleryCards} />
        </div>
      )}
      {isMobile && (
        <div id="mobile_content">
          <MobilePageIntro title={GeneralTexts.Name}
            description={HomeIntroTexts.DescriptiveText}
            backgroundImage={TopSectionsPictures.HomePage}
            modalText={HomeIntroTexts.ModalText}
            buttonText={HomeIntroTexts.ButtonText}
            aboutModal={HomeIntroTexts.AboutModal}
            closeModal={HomeIntroTexts.CloseModal}
            isModalList={true} />
          <MobileEventsSection />
          <HistorySection title={HistorySectionTexts.Title} subtitle={HistorySectionTexts.Subtitle} description={HistorySectionTexts.Description} mainImage={historyMainImage} smallImages={historySmallImages} />
          <MobileGallerySection title={galleryTitle} cards={galleryCards} />
        </div>  
      )}
      <StaticFooter />
      {!isMobile && (
        <Footer />
      )}
      {isMobile && (
        <MobileFooter />
      )}
    </div>
  )
}

export default HomePage